import { isProfileSwitchNavigateDenied } from '@/pages/ProfileSelection/profileSelection-utilities';
import { useLocation, useNavigate } from 'react-router-dom';

const useNavigateGuard = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigate = (path: string) => {
    if (
      isProfileSwitchNavigateDenied() &&
      location.pathname.includes('profile-selection')
    ) {
      window.dispatchEvent(new Event('switchExitDenied'));
      return;
    }

    // Add more conditions here if needed, and trigger
    // a custom event
    const transaction = sessionStorage.getItem('isMidTransaction');
    if (transaction) {
      sessionStorage.setItem('attemptedUrlMidTransaction', path);
      window.dispatchEvent(new Event(`${transaction}-exitDenied`));
      return;
    }

    window.scrollTo({ top: 0, behavior: 'smooth' });
    navigate(path);
  };

  return handleNavigate;
};

export default useNavigateGuard;
